import { RoutePermissionFunction } from "router-manager/parts";
import { useEffect, useState } from "react";
import { useApplicationContext } from "contexts/ApplicationContext";
import {
  GETLicensePayload,
  UserLicensesEndpoints
} from "components/servicos-components/user-licences/utils";
import { ConfirmLicense } from "components/servicos-components/user-licences/confirm-license";
import { LicenseAndBilling } from "components/servicos-components/user-licences/license-and-billing/license-and-billing";
import { GetLayout } from "components/get-layout";
import { isColomboUser } from "utils/is-colombo-user";

export default function Page() {
  const [licenseData, setLicenseData] = useState<Partial<GETLicensePayload>>(
    {}
  );
  const { user } = useApplicationContext();
  const customerId = user.userData.customerId;

  const getLicenseData = async () => {
    try {
      const data = await UserLicensesEndpoints.getLicense(customerId!);
      setLicenseData(data);
    } catch (e) {
      // handle error if needed
    }
  };

  useEffect(() => {
    getLicenseData();
  }, []);

  return (
    <GetLayout>
      {licenseData.configured === false && (
        <ConfirmLicense
          licenseData={licenseData}
          onUpdateLicenses={(data) => {
            if (data) setLicenseData(data);
            else getLicenseData();
          }}
        />
      )}

      {licenseData.configured === true && (
        <LicenseAndBilling
          licenseData={licenseData}
          onUpdateLicenses={(data) => {
            if (data) setLicenseData(data);
            else getLicenseData();
          }}
        />
      )}
    </GetLayout>
  );
}

export const setRoutePermissions: RoutePermissionFunction = (route) => {
  route.addCustomPermission((user) => !!user?.isLogged && !isColomboUser(user));
};
